import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import styles from "./app.module.scss";
import Home from "./pages/Home/Home";
import Contact from "./pages/Contact/Contact";
import FloorPlan from "./pages/FloorPlan/FloorPlan";
import { useState } from "react";
import CallbackForm from "./components/common/CallbackForm/CallbackForm";
import AboutUs from "./pages/AboutUs/AboutUs";
import Location from "./pages/Location/Location";
import ProjectOverview from "./pages/ProjectOverview/ProjectOverview";


//will give scroll to top functionality later
function App() {
  const location = useLocation();
  const [navBar, setNavbar] = useState(false);
  return (
    <div className={styles.App}>
      {/* navbar */}
      
      {(location.pathname !== "/projectOverview" &&
        location.pathname !== "/FloorPlan") && (
        <div className={styles.headerContainer}>
          <img
            className={styles.radianceLogo}
            src="/Radiance-Homes-Patiala-Logo.webp"
            alt="radianceLogo"
          ></img>

          {/* Navbar */}

          <div className={styles.navBar} onClick={() => setNavbar(true)}>
            <span className={styles.nav}></span>
            <span className={styles.nav}></span>
            <span className={styles.nav}></span>
          </div>

          {navBar && (
            <div className={styles.navBarModalContainer}>
              <div className={styles.closeNavbar}>
                <i
                  className="fas fa-times js-menu-toggle"
                  style={{ fontSize: "x-large" }}
                  onClick={() => setNavbar(false)}
                ></i>
              </div>
              <div className={styles.navItemsContainer}>
                <a href="/" className={styles.navItem}>
                  HOME
                </a>
                <a href="/AboutUs" className={styles.navItem}>
                  ABOUT US
                </a>
                <a href="/projectOverview" className={styles.navItem}>
                  PROJECT OVERVIEW
                </a>
                <a href="/location" className={styles.navItem}>
                  LOCATION
                </a>
                <a href="/Contact" className={styles.navItem}>
                  CONTACT US
                </a>
                
                <a
                  className={styles.navItem}
                  href="/SMC.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                   Compliance Document
                   
                </a>
                <a
                  className={styles.navItem}
                  href="/EC_Letter_RadianceHomes.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                   EC Letter
                   
                </a>
               
                <a
                  className={styles.navButton}
                  href="/Radiance_home_brochure.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  DOWNLOAD BROCHURE
                </a>
                
              </div>
            </div>
          )}
        </div>
      )}
      {/* routes */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/FloorPlan" element={<FloorPlan />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/location" element={<Location />} />
        <Route path="/projectOverview" element={<ProjectOverview />} />
      </Routes>

      {/* footer */}
      {(location.pathname !== "/projectOverview" &&
        location.pathname !== "/FloorPlan") && (
        <div className={styles.callbackFormContainer}>
          <h2>Request Callback</h2>
          <CallbackForm />
        </div>
      )}
      <p className={styles.copywrite}>© 2025. All rights reserved. This website belongs to SK Land Pro.<br/>
      Designed and Developed by: Mansi Singla.  </p>
    </div>
  );
}

export default App;
